import React from "react";
import ThemeProvider, {
  ThemeProviderProps,
} from "@material-ui/styles/ThemeProvider";
import createMuiTheme, {
  ThemeOptions,
} from "@material-ui/core/styles/createMuiTheme";
import { enUS, frFR } from "@material-ui/core/locale";

import useEnhancedIntl from "../../hooks/useEnhancedIntl";

export type EnhancedThemeProviderProps = Omit<ThemeProviderProps, "theme"> & {
  themeOptions: ThemeOptions;
};

function EnhancedThemeProvider(props: EnhancedThemeProviderProps) {
  const { themeOptions, ...other } = props;
  const { locale } = useEnhancedIntl();

  const theme = React.useMemo(() => {
    switch (locale) {
      case "en-US":
        return createMuiTheme(themeOptions, enUS);
      case "fr-FR":
        return createMuiTheme(themeOptions, frFR);
      default:
        return createMuiTheme(themeOptions);
    }
  }, [locale, themeOptions]);

  return <ThemeProvider theme={theme} {...other} />;
}

export default EnhancedThemeProvider;
